import {
  type DependencyList,
  type RefObject,
  useEffect,
  useState,
} from "react";

export const useIsHorizontallyScrollable = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  deps: DependencyList = []
): boolean => {
  const [isHorizontallyScrollable, setIsHorizontallyScrollable] =
    useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const el = ref.current;
      if (el) {
        setIsHorizontallyScrollable(el.scrollWidth > el.clientWidth);
      }
    };

    checkScroll();

    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, deps);

  return isHorizontallyScrollable;
};
